import { value } from '@takeshape/util';
import { createUserDefinedPaginationHelper } from "./config-utils.js";
import { paginationSchemes } from "./schemes.js";
export function detectPaginationScheme(projectSchema, propOrQuery) {
    return paginationSchemes.find((scheme) => scheme.predicate(projectSchema, propOrQuery));
}
export function getPaginationHelper(projectSchema, queryConfig, query) {
    const userDefinedPaginationHelper = createUserDefinedPaginationHelper(queryConfig);
    if (userDefinedPaginationHelper) {
        return userDefinedPaginationHelper;
    }
    if (typeof query.shape === 'object' && query.shape.type === 'array' && !query.args) {
        return {
            getArgs: value(undefined),
            hasMore: value(false),
            itemsPath: '$'
        };
    }
    return detectPaginationScheme(projectSchema, query)?.createPaginationHelper();
}
